import axios from "axios";
import Cookies from "../components/cookies";
import config from "../config";


const handleExpiredToken = () => {
    window.location = "/";
}


export const TemplatesList = async () =>{

    const CookieObj = new Cookies();
    let access_token = CookieObj.getCookie("token")
    var templates_list = [];
    axios.defaults.baseURL = config.servers["base"];
    let urlTOload = "templates/get/"
    
    await axios.get(
        urlTOload,
        {
            headers:{
                authorization : "Bearer " + access_token 
            }
        }
    ).then((response)=>{
        if(response.status === 401){
            handleExpiredToken();
        }
        templates_list = response.data;
        
        

    }).catch(error=>{
        if(error.response.status === 401)
        {   
            handleExpiredToken();
        }
        else{
            templates_list = [] 
        }
    })
    return await templates_list

}